import { useQuery } from "@hooks/useQuery";
import { Button, Tabs } from "antd";
import { Children, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { NewsLetterSubscription } from "./NewsLetterSubscription/NewsLetterSubscription";
import { MembersTab } from "./Members/Members";
import { Icon } from "@iconify/react";

export const Members = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(query.get('activeTab') || 'guestUsers');

  useEffect(() => {
    if (!query.get("activeTab")) {
      navigate(`/dedicated/eraman/newsletterSubscription?activeTab=${activeTab}`, {
        replace: true,
      });
    }
  }, [activeTab]);

  const handleTabChange = (newActiveKey:any) => {
    setActiveTab(newActiveKey);
    navigate(`${window.location.pathname}?activeTab=${newActiveKey}`);
  };

  const renderActiveTabContent = () => {
    switch (activeTab) {
      case 'guestUsers':
        return <NewsLetterSubscription />;
      case 'registeredUsers':
        return <MembersTab />;
      default:
        return null;
    }
  };

  const items = [
    {
      label: "Guest Users",
      key: "guestUsers",
    },
    {
      label: "Registered Users",
      key: "registeredUsers",
    },
  ];

  return (
    <ContentWrapper 
      title={"Newsletter Subscription"}
      actionItems={
       activeTab === 'registeredUsers' && (
        <Button
          onClick={() => {
            navigate("/dedicated/eraman/registeredUsers/add");
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add New Member
        </Button>
       )
      }
    >
      <Tabs
        activeKey={activeTab}
        items={items}
        onChange={handleTabChange}
      />
      {renderActiveTabContent()}
    </ContentWrapper>
  );
};